import { render, staticRenderFns } from "./follow-up-modal.vue?vue&type=template&id=194e8a1e&scoped=true"
import script from "./follow-up-modal.vue?vue&type=script&lang=js"
export * from "./follow-up-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194e8a1e",
  null
  
)

export default component.exports